const Permissions = {
  Core: {
    id: 'core',
    code: 100,
    display: 'permissions.core',
    shortDisplay: 'COR',
  },
  Public: {
    id: 'public',
    code: 101,
    display: 'permissions.public',
    shortDisplay: 'PUB',
  },
  PublicDocuments: {
    id: 'public documents',
    code: 103,
    display: 'permissions.public_documents',
    shortDisplay: 'PUB_DOCS',
  },
  PublicComments: {
    id: 'public comments',
    code: 104,
    display: 'permissions.public_comments',
    shortDisplay: 'PUB_COM',
  },
  Elevate: {
    id: 'elevate',
    code: 105,
    display: 'permissions.elevate',
    shortDisplay: 'ELE',
  },
  Private: {
    id: 'private',
    code: 110,
    display: 'permissions.private',
    shortDisplay: 'PRI',
  },
  View_DKP: {
    id: 'DKP view',
    code: 121,
    display: 'permissions.view_dkp',
    shortDisplay: 'VDKP',
  },
  View_DKP2: {
    // DKP nova izmjera - korištena u Ogulinu
    id: 'DKP2 view',
    code: 122,
    display: 'permissions.view_dkp2',
    shortDisplay: 'VDKP2',
  },
  View_Adrese: {
    id: 'Adrese view',
    code: 123,
    display: 'permissions.view_adrese',
    shortDisplay: 'VADR',
  },
  TenantUserAdministration: {
    id: 'Tenant user administration',
    code: 140,
    display: 'permissions.tenant-user_administration',
    shortDisplay: 'TUA',
  },
  TenantCommentAdministration: {
    id: 'Tenant comment administration',
    code: 141,
    display: 'permissions.comment_administration',
    shortDisplay: 'TCA',
  },
  ThreeDView: {
    id: 'threed',
    code: 150,
    display: 'permissions.3d',
    shortDisplay: '3D',
  },
  ThreeDHideGFIButton: {
    id: 'threed-hide-gfi',
    code: 151,
    display: 'permissions.3d_hide_gfi_button',
    shortDisplay: '3DGFI',
  },
  Ena: {
    id: 'ena',
    code: 200,
    display: 'permissions.ena',
    shortDisplay: 'ENA',
  },
  EnaKuceZaOdmor: {
    id: 'ena-kzo',
    code: 202,
    display: 'permissions.ena_kzo',
    shortDisplay: 'KZO',
  },
  EnaViewNekretnine: {
    id: 'ena-view-nek',
    code: 203,
    display: 'permissions.view-nekretnine',
    shortDisplay: 'EVN',
  },
  EnaManageNekretnine: {
    id: 'ena-manage-nek',
    code: 204,
    display: 'permissions.manage-nekretnine',
    shortDisplay: 'EMN',
  },
  Rasvjeta: {
    id: 'rasvjeta',
    code: 300,
    display: 'permissions.rasvjeta',
    shortDisplay: 'RAS',
  },
  RasvjetaPhotodoc: {
    id: 'rasvjeta-photodoc',
    code: 301,
    display: 'permissions.rasvjeta_photodoc',
    shortDisplay: 'PRAS',
  },
  NerazvrstaneCeste: {
    id: 'nerazvrstane-ceste',
    code: 350,
    display: 'permissions.nerazvrstane_ceste',
    shortDisplay: 'NC',
  },
  Groblja: {
    id: 'groblja',
    code: 400,
    display: 'permissions.groblja',
    shortDisplay: 'GRO',
  },
  GrobljaManageOsnovniRegistri: {
    id: 'groblja-manage-osnovni-registri',
   code: 401,
    display: 'permissions.cemetaries_basic_registries',
    shortDisplay: 'GRO-OR',
  },
  GrobljaManageRegistarKremiranih: {
    id: 'groblja-manage-registar-kremiranih',
      code: 402,
    display: 'permissions.cementaries_registry_cremated',
    shortDisplay: 'GRO-RK',
  },
  GrobljaUpitnik: {
    id: 'groblja-upitnik-public',
    code: 410,
    display: 'permissions.groblja_upitnik_public',
    shortDisplay: 'GRO-UPT',
  },
  GrobljaUpitnikAdmin: {
    id: 'groblja-upitnik-admin',
    code: 411,
    display: 'permissions.groblja_upitnik_admin',
    shortDisplay: 'GRO-UPA',
  },
  GrobljaUpitnikOdgovori: {
    id: 'groblja-upitnik-odgovori',
    code: 412,
    display: 'permissions.groblja_upitnik_odgovori',
    shortDisplay: 'GRO-UPO',
  },
  Parking: {
    id: 'parking',
    code: 500,
    display: 'permissions.parking',
    shortDisplay: 'PAR',
  },
  PlinSimulacijeVentila: {
    id: 'plin-simulacije-ventila',
    code: 510,
    display: 'permissions.plin_simulacije_ventila',
    shortDisplay: 'PLIN-SIM',
  },
  Chem: {
    id: 'chem',
    code: 600,
    display: 'permissions.chem',
    shortDisplay: 'CHEM',
  },
  KoncesijeView: {
    id: 'koncesije-view',
    code: 650,
    display: 'permissions.koncesije_view',
    shortDisplay: 'KON-V',
  },
  KoncesijeEdit: {
    id: 'koncesije-edit',
    code: 651,
    display: 'permissions.koncesije_edit',
    shortDisplay: 'KON-e',
  },
  ProstorniPlanoviView: {
    id: 'prostorni-planovi-view',
    code: 700,
    display: 'permissions.prostorni_planovi',
    shortDisplay: 'PP',
  },
  PPZahtjeviView: {
    id: 'pp-zahtjevi-view',
    code: 701,
    display: 'permissions.pp_zahtjevi_view',
    shortDisplay: 'PPZV',
  },
  PPZahtjeviManage: {
    id: 'pp-zahtjevi-manage',
    code: 702,
    display: 'permissions.pp_zahtjevi_manage',
    shortDisplay: 'PPZM',
  },
  PPRegistarView: {
    id: 'pp-registar-view',
    code: 703,
    display: 'permissions.pp_registar_view',
    shortDisplay: 'PPRV',
  },
  CestovnaInfrastruktura: {
    id: 'cestovna-infrastruktura',
    code: 750,
    display: 'permissions.cestovna_infrastruktura',
    shortDisplay: 'CI',
  },
  CestovnaInfrastrukturaEdit: {
    id: 'groblja-edit',
    code: 751,
    display: 'permissions.cestovna_infrastruktura_edit',
    shortDisplay: 'ECI',
  },
  PristupacnostCore: {
    id: 'pristupacnost-core',
    code: 850,
    display: 'permissions.pristupacnost_core',
    shortDisplay: 'PRST-CORE',
  },
  PristupacnostViewGrades: {
    id: 'test',
    code: 851,
    display: 'permissions.test',
    shortDisplay: 'PRST-VIEW-GRD',
  },
  Administration: {
    id: 'administration',
    code: 990,
    display: 'permissions.administration',
    shortDisplay: 'ADM',
  },
};

export default Permissions;
